import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteMultiCartComment } from 'api/cart/deleteMultiCartComment'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { COMMENT_QUERY_KEY } from 'constants/comments'

interface DeleteCommentParams {
  multiCartId: string
  commentId: string
}

export function useDeleteMultiCartComment() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: DeleteCommentParams) => deleteMultiCartComment(
      params.multiCartId,
      params.commentId,
    ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [COMMENT_QUERY_KEY, variables.multiCartId] })
    },
    onError: (error: Error) => {
      showSnackbar(`Failed to delete comment: ${error.message}`, 'critical')
    },
  })
}
